import Common from '../../Common';

const GenericRecording = class extends Common {
	mp3 = (companyId: id, id: id): CustomResponse<Blob> =>
		this.get(`/company/${companyId}/generic-recordings/${id}/mp3`, {}, { responseType: 'blob' })

	delete = (companyId: id, id: id) =>
		this.doDelete(`/company/${companyId}/generic-recordings/${id}`)
}

export default GenericRecording
